export default {
    "create-document": "Crear un documento de transferencia",
    "delete-document": "Eliminar documento",
    "are-you-sure-you-want-to-delete-the-document": "¿Estás seguro de que deseas eliminar el documento?"
}